import { AuthService } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  email: string;
};

export const recoverPassword = ({ call, email }: TParams) =>
  call(() => AuthService.recover({ requestBody: { email } }));
